import { merge } from 'ramda';

import * as types from '../constants/ActionTypes'
import { objectify } from '../helpers/ReducerUtils';

const users = (state = {}, action) => {
  switch (action.type) {
    case types.SEARCH_USERS_SUCCESS:
      return merge(state, objectify(action.payload));
    case types.USER_CREATED: {
      const user = action.payload;
      return merge(state, { [user.id]: user} );
    }
    case types.USER_UPDATED: {
      const user = action.payload;
      return merge(state, { [user.id]: user });
    }
    case types.USER_STATUS_CHANGED:
      const { userId, status } = action.payload;
      const user = state[userId];
      return {
        ...state,
        [userId] : {
          ...user,
          status
        }
      };
    default:
      return state;
  }
};

export default users;
